import { render, staticRenderFns } from "./PrivateDonationArea.vue?vue&type=template&id=0b8f325d"
import script from "./PrivateDonationArea.vue?vue&type=script&lang=ts"
export * from "./PrivateDonationArea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports